import React from 'react';
import { NavBar } from './NavBar';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export const Layout = ({
  children
}: LayoutProps) => {
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-53">
      <NavBar data-id="element-54" />
      <main className="flex-grow w-full" data-id="element-55">{children}</main>
      <Footer data-id="element-56" />
    </div>;
};